import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayTechnologiesBusiness extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });

    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Subject <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Implementation of Technology in Business on the Example of Zara</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>Zara is one of the most world recognizable brands due to the positive influence of information communication technologies, which promote their trademark, as well as the customer relationship management systems.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required question “Does having technology in a business enhance or hurt their chances for success?” explicitly. </li>
                  <li>Structure: The introduction contains an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>
                Information communication is the first key to Zara’s success as it affects strongly the development of its effective selling strategy. The “living fashion” plan implemented at Zara means that the company focuses on redesigning new output lines every two weeks (García-Álvarez 998). Such a strategy has been developed by the means of co-learning from the application of the information and communication technologies. The received infromation contributes greatly to successful knowledge management operation (Malafe and Fahime 196). For example, the knowledge management benefits the company through elimination of barriers in communication in the process of gathering, storing, and exchanging information (Malafe and Fahime 198). The combination of wisely-used technologies helps Zara significantly increase its performance.
            </p>
              <div className={styles.comment}>
                <ul>
                  <li> Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in MLA.</li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>Using the customer relationship management systems as the second tool of applying modern technologies enables Zara to affect the level of customer loyalty. Most clients all over the world prefer Zara to other brands because it offers unique fashionable clothes that meet their needs in terms of physical, climate, and cultural differences (Roll, Martin 2018). This has bebome possible due to conducting a deep research on the customers’ values, preferences, and geographic peculiarities via “collaborative and analytical systems” (Khodakarami, and Yolande 32). The application of data received from the customers helps the company move in the right direction. As a result, the customers’ needs and requirements are addressed, thus providing Zara with loyal clients, as well as a substantial advantage over other companies on the market.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with an example from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>Zara is one of the most successful world companies due to the effective application of information and communication technologies that influence the development of selling strategy and enhance customer loyalty.</p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis.</li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">

            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>García-Álvarez, María Teresa. "Analysis of the effects of ICTs in knowledge management and</div>
              <p>innovation: The case of Zara Group." <i>Computers in Human Behavior</i> 51 (2015): 994-</p>
              <p>1002.</p>

              <div>Khodakarami, Farnoosh, and Yolande E. Chan. "Exploring the role of customer relationship </div>
              <p>management (CRM) systems in customer knowledge creation." <i>Information &</i></p>
              <p><i>Management</i> 51.1 (2014): 27-42.</p>

              <div>Malafe, Neda Sharifi Asadi, and Fahime Baei. "The Analysis of Using ICT on Knowledge </div>
              <p>Management in Governmental Organizations in Iran (Case Study: Municipality of </p>
              <p>Mazandaran Province)." <i>Journal of Management Research</i> 9.4 (2017): 196-206.</p>

              <div>Roll, Martin. “The Secret of Zara’s Success: a Culture of Customer Co-creation.” <i>Business</i> </div>
              <p><i>and Brand Leadership</i>, https://martinroll.com/resources/articles/strategy/the-secret-of</p>
              <p>-zaras-success-a-culture-of-customer-co-creation/. Accessed 22 April 2018.</p>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic. The required source is included.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style.</li>
                  <li>The list of sources is alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayTechnologiesBusiness);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayTechnologiesBusiness.js